import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@drone-js/core';
import { getImageUrl } from 'core/utils/activityUrlGenerator';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

const NoAvailableOption: React.FC = () => {
    const cms = useSelector(selectCmsFromBootstrap);
    return (
        <Box display="flex" flexDirection="column" width="100%" alignItems="center" data-testid="no-available-option">
            <Box my="12">
                {/* eslint-disable-next-line @agoda/agoda-a11y/no-non-drone-image -- @agoda/agoda-a11y/no-non-drone-image[fbb8342e-1c86-4ee5-8ca6-a19d4ef59cfa] */}
                <img alt={cms[127086]} src={getImageUrl('no-option.svg')} />
            </Box>
            <Typography tag="h2" variant="heading-default">
                {cms[127086]}
            </Typography>
            <Typography mx="24" my="8" textAlign="start" variant="body-s" textColor="base.subtle">
                {cms[239107]}
            </Typography>
        </Box>
    );
};
NoAvailableOption.displayName = 'NoAvailableOption';

export default NoAvailableOption;
